import action from '../../assets/promoIcons/action.svg';
import discount from '../../assets/promoIcons/discount.svg';
import maternalCapital from '../../assets/promoIcons/maternalCapital.svg';
import militaryMortgage from '../../assets/promoIcons/militaryMortgage.svg';
import mortgage from '../../assets/promoIcons/mortgage.svg';
import { EPromoType } from '../../types/newbuilding/promos';

export const PROMO_ICON = new Map<EPromoType, string>([
  [EPromoType.Discount, discount],
  [EPromoType.MilitaryMortgage, militaryMortgage],
  [EPromoType.Bonus, action],
  [EPromoType.Mortgage, mortgage],
  [EPromoType.MaternalCapital, maternalCapital],
  [EPromoType.Installment, mortgage],
]);
